export default {
    modal: {
        comments: 'Commentaires',
        negativeQuestion: "Qu'est-ce qui vous déplaît de cette version ?",
        neutralQuestion: 'Quelles sont vos suggestions ?',
        positiveQuestion: "Qu'aimez-vous de cette version ?",
        suggestions: 'Suggestions',
    },
};
